import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import Flex from 'components/common/Flex';

export const IntegrationBrand = () => {
  const brands = [
    {
      name: 'TecnoGestión',
      progress: '100',
      status: 'Integrado',
      logo: 'https://www.tecnogestion.com.ar/assets/img/tecnogestion.png',
      url: 'https://www.tecnogestion.com.ar/'
    },
    {
      name: '2clics',
      progress: '100',
      status: 'Integrado',
      logo: 'https://app.2clics.com.ar/img/2clics.svg',
      url: 'https://app.2clics.com.ar/'
    },
    {
      name: 'SOM',
      progress: '100',
      status: 'Integrado',
      logo: 'http://www.som.com.ar/wp-content/uploads/2017/11/som.gif',
      url: 'https://www.som.com.ar/'
    },
    {
      name: 'Ela Gestión',
      progress: '100',
      status: 'Integrado',
      logo: 'https://res.cloudinary.com/dchaozfok/image/upload/v1692363302/rxa0oejooti9eenkgb7g.png',
      url: 'https://www.elagestion.com/'
    },
    {
      name: 'Pixel Inmobiliario',
      progress: '100',
      status: 'Integrado',
      logo: 'https://pixelinmobiliario.com/img/logo.png',
      url: 'https://pixelinmobiliario.com/'
    },
    {
      name: 'Mapaprop',
      progress: '100',
      status: 'Integrado',
      logo: 'https://www.mapaprop.com/img/mapaprop-icon.svg',
      url: 'https://www.mapaprop.com?ref=127'
    },
    {
      name: 'Xintel',
      progress: '100',
      status: 'Integrado',
      logo: 'https://www.comparasoftware.co/wp-content/uploads/2020/01/logoxintel.png',
      url: 'https://www.xintel.com.ar/'
    },
    {
      name: 'Kiteprop',
      progress: '100',
      status: 'Integrado',
      logo: 'https://www.kiteprop.com/assets-v2/admin/img/kp_logo_og.png',
      url: 'https://www.kiteprop.com/'
    }
  ];

  return (
    <>
      {brands.map((brand, index) => (
        <tr key={index}>
          <td>
            <Flex alignItems="center" className="position-relative">
              <img
                className="rounded-1 border border-200"
                src={brand.logo}
                width="60"
                alt={brand.name}
              />
              <div className="ms-3">
                <h6 className="mb-1 fw-semi-bold">
                  <a
                    className="text-dark stretched-link"
                    href={brand.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {brand.name}{' '}
                  </a>
                </h6>
                <p className="fw-semi-bold mb-0 text-500">{brand.status}</p>{' '}
              </div>
            </Flex>
          </td>
          <td className="align-middle pe-x1">
            <Flex alignItems="center">
              <ProgressBar
                now={brand.progress}
                style={{ width: '80px', height: 5 }}
              />{' '}
              <div className="fw-semi-bold ms-3">{brand.progress}%</div>{' '}
            </Flex>
          </td>
        </tr>
      ))}
    </>
  );
};
